import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useLocation, useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";


const Rep_gst = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownType = location.state?.dropdownType;
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [GenerateType, setGenerateType] = useState("V");
    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");
    const [scr, setScr] = useState("");
    const [repLevel, setRepLevel] = useState("G");
    const [stateCode, setStateCode] = useState("0");
    const [state, setState] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [filterReportType, setFilterReportType] = useState('A');
    const [filterStateOption, setFilterStateOption] = useState('A');
    const [filterTransacionType, setFilterTransactionType] = useState("A");
    const [transactionTypeValue, setTransactionTypeValue] = useState("PP");
    const [filterGstin, setFilterGstin] = useState("");
    const [stateName, setStateName] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REPORT_GST'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Date should be within financial year");
            return;
        } else if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        const obj = {
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            fromDateDMY: Common.dateDMY(fromDate),
            toDateDMY: Common.dateDMY(toDate),
            stateCode: stateCode,
            filterStateOption: filterStateOption,
            filterTransacionType: filterTransacionType,
            transactionType: transactionTypeValue,
            gstin: filterGstin,
            stateName: stateName,
            filterReportType: filterReportType
        };
        if (GenerateType === 'D') {
            Common.callDownloadApiPost1(Common.apirepgst, "post", [sid, "repGstDownloadReport", JSON.stringify(obj)], result => {
                console.log("this is result ", result);
                $(".loader").hide();
                setMsgText(Common.buildMessageFromArray([result]));
                setMsgBox(true);
            });
        } else {
            Common.callApi(Common.apirepgst, [sid, "repGstViewReport", JSON.stringify(obj)], result => {
                var newWindow = window.open();
                newWindow.document.write(result);
                $(".loader").hide();
            });
        }
    }
    const handleStateValue = (value) => {
        setState(value);
        const stt = value.id.split('^');
        setStateCode(stt[1]);
        setStateName(stt[2]);
        setFilterGstin(stt[3]);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Report GST</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                <Row>
                    <Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>State<span className="text-danger">*</span></Form.Label>
                                <Form.Select value={filterStateOption} onChange={e => setFilterStateOption(e.target.value)}
                                    required>
                                    <option value="A">All</option>
                                    <option value="O">One</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {filterStateOption === 'O' ?
                            <>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>State<span className="text-danger">*</span>
                                        </Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={state}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchEntityWiseStatePicklist(search, 1)}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleStateValue}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </> : null}
                    </Row>
                    <Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Report Type <span className="text-danger">*</span></Form.Label>
                                <Form.Select value={filterReportType} onChange={e => setFilterReportType(e.target.value)}
                                    required>
                                    <option value="A">All</option>
                                    <option value="T">Taxable</option>
                                    <option value="E">Exempted</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Transaction Type <span className="text-danger">*</span></Form.Label>
                                <Form.Select value={filterTransacionType} onChange={e => setFilterTransactionType(e.target.value)}
                                    required>
                                    <option value="A">All</option>
                                    <option value="O">One</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {filterTransacionType === 'O' ?
                            <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Transaction Type  <span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={transactionTypeValue} onChange={e => setTransactionTypeValue(e.target.value)}
                                            required>
                                            {(filterReportType === 'T' || filterReportType === 'A') ?
                                                <>
                                                    <option value="PP">Purchase Public</option>
                                                    <option value="SP">Sale Public</option>
                                                    <option value="SI">Sale Invoice</option>
                                                </> : null
                                            }
                                            {
                                                (filterReportType === 'E' || filterReportType === 'A') ?
                                                    <>
                                                        <option value="PB">Purchase Bulk</option>
                                                        <option value="SB">Sale Bulk</option>
                                                        <option value="OT">ADII Settlement</option>
                                                        <option value="VT">VTM Settlement</option>
                                                        <option value="GVT">GVTM Settlement</option>
                                                    </> : null
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </> : null}
                    </Row>
                    <Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label> From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={fromDate}
                                    onChange={(date) => setFromDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label> To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={toDate}
                                    onChange={(date) => setToDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={GenerateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_gst;
